import styled from 'styled-components';
import { font } from '@chegg-ui/theme';
var family = font.family;
export var OneClickContainer = styled.div.withConfig({
  componentId: "sc-1s8fqxv-0"
})(["font-family:", ";background:white;position:relative;"], family.aspira);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/one-click/dist/esm/views/OneClick/styled.js
// module id = 5218
// module chunks = 11